import App from "./app"
import { startStoredLanguage } from "./i18n"
import { startTransportFailureTelemetry } from "./observability/offline-transport-buffer"
import {
  scrubBreadcrumbFragments,
  scrubUrlFragments
} from "./observability/scrub-url-fragments"
import * as serviceWorker from "./serviceWorker"
import store from "./store"
import React from "react"
import { createRoot } from "react-dom/client"
import * as Sentry from "@sentry/react"

const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
    tracesSampleRate: 0.1,
    sendDefaultPii: true,
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications"
    ],
    denyUrls: [
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-web-extension:\/\//i,
      /^chrome:\/\//i,
      /extensions\//i
    ],
    // A signing link's token lives in the URL fragment so that it never reaches
    // a server. Sentry reads location.href on every event, which would carry it
    // out of the browser anyway.
    beforeSend: scrubUrlFragments,
    beforeBreadcrumb: scrubBreadcrumbFragments
  })
}

startTransportFailureTelemetry()

const container = document.getElementById("root")

if (!container) {
  throw new Error("Failed to find the root element")
}

const root = createRoot(container)

Promise.all([store(), startStoredLanguage()])
  .then(([s]) => {
    root.render(
      // <React.StrictMode>
      <App store={s} />
      // </React.StrictMode>
    )
  })
  .catch((err: Error) => {
    console.error(err.message)
  })

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
